import moment from 'moment';

export const SERP_MONITORING_XLSX_FILENAME = `serp-monitoring-${moment().format('YYYY-MM-DD')}.xlsx`;
